export * from './externalLaboratory.service';